export default class AppsTemplateService {
    constructor(gudhub) {
        this.gudhub = gudhub;
        this.appsConnectingMap = {
            apps: [],
            fields: [],
            items: [],
            views: []
        }
    }

    createAppsFromTemplate(pack, maxNumberOfInsstalledItems, progressCallback, installFromMaster) {
        const self = this;
        return new Promise(resolve => {
            const stepsCount = pack.apps.length * 6;
            const stepPercents = 100 / stepsCount;
            let currentStep = 0;
            self.createApps(pack, (status) => {
                currentStep += 1;
                progressCallback ? progressCallback.call(this, {
                    percent: currentStep * stepPercents,
                    status
                }) : null;
            }, installFromMaster).then(success => {
                self.createItems(success, maxNumberOfInsstalledItems, (status) => {
                    if (typeof status === 'string') {
                        currentStep += 1;
                        progressCallback ? progressCallback.call(this, {
                            percent: currentStep * stepPercents,
                            status
                        }) : null;
                    } else if (typeof status === 'object') {
                        progressCallback ? progressCallback.call(this, {
                            status: 'Done',
                            apps: status
                        }) : null;
                        resolve();
                    }
                }, installFromMaster)
            })
        });
    }

    createItems(create_apps, maxNumberOfInsstalledItems, callback, installFromMaster) {
        return new Promise(async (resolve) => {
            const MAX_NUMBER_OF_INSTALLED_ITEMS = maxNumberOfInsstalledItems ? maxNumberOfInsstalledItems : 100000;
            const self = this;
            let createsItems = [];
            let promises = [];

            const { accesstoken } = await self.gudhub.req.axiosRequest({
                method: 'POST',
                url: 'https://gudhub.com/GudHub_Test/auth/login',
                form: {
                    auth_key: '3HMOtCbC0M/1/1e4y4Uxo/Kh/aFN4V5LG2//5ixx7TZyiUfMb7IHAAHCj9PsLrOSDrZuuWkbX4BIX23f51H+eA=='
                }
            });

            create_apps.forEach(app => {
                promises.push(new Promise(async (app_resolve) => {
                    let result_app;
                    if(installFromMaster) {
                        result_app = await self.gudhub.req.axiosRequest({ url: `https://gudhub.com/GudHub_Test/api/app/get?token=${accesstoken}&app_id=${self._searchOldAppId(app.app_id, self.appsConnectingMap.apps)}`, method: 'GET' });
                    } else {
                        result_app = await self.gudhub.getApp(self._searchOldAppId(app.app_id, self.appsConnectingMap.apps));
                    }
                    callback ? callback.call(this, `GET APP: ${result_app.app_name} (Items steps)`) : null;
                    let source_app = JSON.parse(JSON.stringify(result_app));
                    let items = source_app.items_list.map(item => {
                        return {
                            index_number: item.index_number,
                            item_id: 0,
                            fields: []
                        }
                    }).filter((item, index) => index <= MAX_NUMBER_OF_INSTALLED_ITEMS);
                    self.gudhub.addNewItems(app.app_id, items).then(items => {
                        callback ? callback.call(this, `ADD NEW ITEMS: ${result_app.app_name} (Items steps)`) : null;

                        app.items_list = items;
                        self._updateMap(app.items_list, source_app.items_list);
                        self._addFieldValue(source_app.items_list, app.items_list, self.appsConnectingMap);

                        createsItems.push(app);

                        app_resolve();
                    });
                }));
            });

            Promise.all(promises).then(() => {

            createsItems.forEach(app => {
                app.items_list.forEach(item => {
                    item.fields.forEach(field_item => {
                        self.appsConnectingMap.fields.forEach(field_map => {
                            if (field_item.field_id === field_map.old_field_id) {
                                field_item.field_id = field_map.new_field_id;
                                field_item.element_id = field_map.new_field_id;
                            }
                        })
                    })
                })
            });

            self.deleteField(createsItems);

            self.replaceValue(createsItems, self.appsConnectingMap).then(() => {
                
                const promises = [];

                createsItems.forEach(created_app => {
                    promises.push(new Promise(resolve => {
                        let newItems = created_app.items_list.map(item => {
                            item.fields.forEach(field => {
                                delete field.data_id;
                            });
                            return item;
                        });
                        
                        self.gudhub.updateItems(created_app.app_id, newItems).then(() => {
                            callback ? callback.call(this, `REPLACE VALUE: ${created_app.app_name} (Items steps)`) : null;
                            resolve();
                        })
                    }));
                });
                
                Promise.all(promises).then(() => {
                    callback.call(this, createsItems);
                    resolve();
                });

            });
            })
        })
    }

    deleteField(apps) {
        apps.forEach(app => {
            app.items_list.forEach(item => {
                item.fields = item.fields.filter(field => {
                    return app.field_list.findIndex(f => f.field_id == field.field_id) > -1;
                })
            })
        })
    }

    replaceValue(apps, map) {
        return new Promise(async (resolve) => {
            const allPromises = [];
            const self = this;

            apps.forEach(app => {
                app.field_list.forEach(field_of_list => {
                    if (field_of_list.data_type === 'item_ref') {
                        self._replaceValueItemRef(app, field_of_list, map);
                    }

                    allPromises.push(new Promise(resolve => {
                            self.gudhub.ghconstructor.getInstance(field_of_list.data_type).then(data => {
                                if(typeof data === 'undefined') {
                                    console.log('ERROR WHILE GETTING INSTANCE OF ', field_of_list.data_type);
                                    resolve({
                                        type: field_of_list.data_type
                                    });
                                    return;
                                }
                                if (data.getTemplate().constructor == 'file') {
                                    return self.gudhub.util.fileInstallerHelper(app.app_id, app.items_list, field_of_list.field_id).then(result => {
                                        resolve(result);
                                    });
                                } else if (data.getTemplate().constructor == 'document') {
                                    self.documentInstallerHelper(app.app_id, app.items_list, field_of_list.field_id).then(result => {
                                        resolve(data);
                                    })
                                } else {
                                    resolve(data);
                                }
                            })
                    }))
                })
            });

            if (allPromises.length > 0) {

                Promise.all(allPromises).then(result => {
                    resolve(result);
                });

            } else {
                resolve(result);
            }

        });
    }

    documentInstallerHelper(appId, items, elementId) {
        const self = this;
        const itemsWithClonedDocument = [];

        return new Promise(async (resolve) => {
            for(const item of items) {
                const itemId = item.item_id;
                const field = item.fields.find(field => field.element_id === elementId);

                if (field && field.field_value && field.field_value.length > 0) {
                    const document = await self.gudhub.getDocument({
                        _id: field.field_value
                    });

                    if(document && document.data) {
                    
                        const newDocument = await self.gudhub.createDocument({
                            app_id: appId,
                            item_id: itemId,
                            element_id: elementId,
                            data: document.data
                        });

                        field.field_value = newDocument._id;

                        itemsWithClonedDocument.push(item);
                    }
                }
            }
            resolve(itemsWithClonedDocument);
        });
    }

    _replaceValueItemRef(app, field_of_list, map) {
        app.items_list.forEach(item => {
            item.fields.forEach(field_of_item => {
                if (field_of_item.field_id === field_of_list.field_id && field_of_item.field_value) {
                    let arr_values = field_of_item.field_value.split(',');

                    arr_values.forEach((one_value, key) => {
                        let value = one_value.split('.');

                        map.apps.forEach(app_ids => {
                            if (value[0] == app_ids.old_app_id) {
                                value[0] = app_ids.new_app_id;
                            }
                        });

                        map.items.forEach(item_ids => {
                            if (value[1] == item_ids.old_item_id) {
                                value[1] = item_ids.new_item_id;
                            }
                        });

                        arr_values[key] = value.join('.')

                    });

                    field_of_item.field_value = arr_values.join(',');

                }
            });
        })
    }

    _addFieldValue(source_app_items, create_items, appsConnectingMap) {
        create_items.forEach(new_item => {
            appsConnectingMap.items.forEach(item_of_map => {
                if (new_item.item_id === item_of_map.new_item_id) {
                    source_app_items.forEach(old_item => {
                        if (item_of_map.old_item_id === old_item.item_id) {
                            new_item.fields = old_item.fields;
                        }
                    })
                }
            })
        })
    }

    _updateMap(new_items, old_items) {
        old_items.forEach(old_item => {
            new_items.forEach(new_item => {
                if (old_item.index_number === new_item.index_number) {
                    this.appsConnectingMap.items.push({
                        old_item_id: old_item.item_id,
                        new_item_id: new_item.item_id
                    })
                }
            })
        })
    }

    _searchOldAppId(app_id, apps) {
        let findId = 0;

        apps.forEach(value => {
            if (value.new_app_id === app_id) {
                findId = value.old_app_id;
            }
        });

        return findId;
    }

    createApps(pack, callback, installFromMaster) {
        const self = this;

        let progress = {
            step_size: 100 / (pack.apps.length * 3),
            apps: []
        }

        return new Promise(async (resolve) => {
            let source_apps = {};
            let created_apps = [];
            let updated_apps = [];

            const { accesstoken } = await self.gudhub.req.axiosRequest({
                method: 'POST',
                url: 'https://gudhub.com/GudHub_Test/auth/login',
                form: {
                    auth_key: '3HMOtCbC0M/1/1e4y4Uxo/Kh/aFN4V5LG2//5ixx7TZyiUfMb7IHAAHCj9PsLrOSDrZuuWkbX4BIX23f51H+eA=='
                }
            });

            for(const app_id of pack.apps) {
                let result_app;

                if(installFromMaster) {
                    result_app = await self.gudhub.req.axiosRequest({ url: `https://gudhub.com/GudHub_Test/api/app/get?token=${accesstoken}&app_id=${app_id}`, method: 'GET' });
                } else {
                    result_app = await self.gudhub.getApp(app_id);
                }
               
                callback ? callback.call(this, `GET APP: ${result_app.app_name} (App steps)`) : null;
                let source_app = JSON.parse(JSON.stringify(result_app));
                source_apps[source_app.app_id] = source_app;
                progress.apps.push(source_app.icon);

                let appTemplate = self.prepareAppTemplate(source_app);
                appTemplate.app_name = appTemplate.app_name + ' New';
                appTemplate.privacy = 1;
                if(pack.data_to_change) {
                    if(pack.data_to_change.name) {
                        appTemplate.app_name = pack.data_to_change.name;
                    }
                    if(pack.data_to_change.icon) {
                        appTemplate.icon = pack.data_to_change.icon;
                    }
                }
                self.resetViewsIds(appTemplate);

                self.gudhub.createNewApp(appTemplate).then(created_app => {
                    callback ? callback.call(this, `CREATE NEW APP: ${result_app.app_name} (App steps)`) : null;
                    created_apps.push(created_app);
                    self.mapApp(source_app, created_app, self.appsConnectingMap);

                    if (pack.apps.length == created_apps.length) {
                        self.connectApps(created_apps, self.appsConnectingMap, source_apps);

                        created_apps.forEach(created_app => {
                            self.gudhub.updateApp(created_app).then(updated_app => {
                                callback ? callback.call(this, `UPDATE APP: ${result_app.app_name} (App steps)`) : null;
                                updated_apps.push(updated_app);

                                if (pack.apps.length == updated_apps.length) {
                                    resolve(updated_apps);
                                }
                            })
                        })
                    }
                });
            }
        });
    }

    mapApp(base_app, new_app, appsConnectingMap) {
        appsConnectingMap.apps.push({
            old_app_id: base_app.app_id,
            new_app_id: new_app.app_id,
            old_view_init: base_app.view_init,
            new_view_init: new_app.view_init
        });

        base_app.field_list.forEach(old_field => {
            new_app.field_list.forEach(new_field => {
                if (old_field.name_space == new_field.name_space) {
                    appsConnectingMap.fields.push({
                        name_space: old_field.name_space,
                        old_field_id: old_field.field_id,
                        new_field_id: new_field.field_id
                    })
                }
            })
        });

        base_app.views_list.forEach(old_view => {
            new_app.views_list.forEach(new_view => {
                if (old_view.name == new_view.name) {
                    appsConnectingMap.views.push({
                        name: old_view.name,
                        old_view_id: old_view.view_id,
                        new_view_id: new_view.view_id
                    })
                }
            })
        })
    }

    crawling(object, action) {
        let properties = object === null ? [] : Object.keys(object);
        const self = this;

        if (properties.length > 0) {
            properties.forEach(prop => {
                let propertyValue = object[prop];

                if (typeof propertyValue !== 'undefined' && typeof object != 'string') {
                    action(prop, propertyValue, object);
                    self.crawling(propertyValue, action);
                }
            })
        }
    }

    resetViewsIds(app) {
        app.view_init = 0;

        this.crawling(app.views_list, function (prop, value, parent) {
            if (prop == 'view_id' || prop == 'container_id') {
                parent[prop] = 0;
            }
        })
    }

    connectApps(apps, appsConnectingMap, source_apps) {
        const self = this;

        apps.forEach(app => {
            appsConnectingMap.apps.forEach(appMap => {
                if (app.view_init === appMap.new_view_init) {
                    appsConnectingMap.views.forEach(view => {
                        if (appMap.old_view_init === view.old_view_id) {
                            app.view_init = view.new_view_id;
                        }
                    })
                }
            });

            self.crawling(app.field_list, function (prop, value, parent) {
                if (prop.indexOf("field_id") !== -1 || prop.indexOf("FieldId") !== -1 || prop.indexOf("destination_field") !== -1) {
                    let fieldsArr = String(value).split(','), newFieldsArr = [];

                    appsConnectingMap.fields.forEach(field => {
                        fieldsArr.forEach(fieldFromValue => {
                            if (fieldFromValue == field.old_field_id) {
                                newFieldsArr.push(field.new_field_id);
                            }
                        })
                    })

                    if (newFieldsArr.length) {
                        parent[prop] = newFieldsArr.join(',');
                    }
                }

                if (prop.indexOf("app_id") != -1 || prop.indexOf("AppId") != -1 || prop.indexOf("destination_app") != -1) {
                    appsConnectingMap.apps.forEach(app => {
                        if (value == app.old_app_id) {
                            parent[prop] = app.new_app_id;
                        }
                    })
                }

                if (prop.indexOf("view_id") !== -1) {
                    appsConnectingMap.views.forEach(view => {
                        if (value == view.old_view_id) {
                            parent[prop] = view.new_view_id;
                        }
                    })
                }

                if (prop.indexOf("src") !== -1 && isFinite(value)) {
                    const pron_name = 'container_id';
                    const old_app_id = appsConnectingMap.apps.find(appMap => appMap.new_app_id === app.app_id).old_app_id;
                    const path = self.findPath(source_apps[old_app_id].views_list, pron_name, value);

                    parent[prop] = `${self.getValueByPath(app.views_list, path, pron_name)}`;
                }

                if (prop.indexOf("trigger") !== -1 && value.model && value.model.nodes) {
                    const nodes = value.model.nodes;
                    const nodeProperties = ["inputs", "outputs"];

                    for (const index in nodes) {
                        nodeProperties.forEach((property) => {
                            const node = nodes[index];
                            const numericProperties = Object.keys(node[property]).filter(prop => prop !== '' && !isNaN(prop)); // field_id as keys

                            numericProperties.forEach((old_field_id) => {
                                const correspondFieldOfConnectingMap = appsConnectingMap.fields.filter((field) => field.old_field_id == old_field_id);

                                if (correspondFieldOfConnectingMap.length !== 0 && correspondFieldOfConnectingMap[0].new_field_id) {
                                    const new_field_id = correspondFieldOfConnectingMap[0].new_field_id.toString();

                                    const connectionObjectCopy = node[property][old_field_id];
                                    connectionObjectCopy.connections.forEach((connection) => {
                                        if (connection.input == old_field_id) {
                                            connection.input = new_field_id;
                                        }
                                        if (connection.output == old_field_id) {
                                            connection.output = new_field_id;
                                        }
                                    });

                                    delete node[property][old_field_id];

                                    node[property][new_field_id] = connectionObjectCopy;
                                }
                            });
                        });
                    };
                }
            })
        })

        return apps;
    }

    getValueByPath(source, path, prop) {
        let temp = source;

        path.split('.').forEach(item => {
            temp = temp[item];
        })

        return temp[prop];
    }

    findPath(source, prop, value) {
        const self = this;

        let isFound = false;
        let toClearPath = false;
        let path = [];

        self.crawling(source, function (propSource, valueSource, parentSource) {
            if (toClearPath) {
                path.reverse().forEach(item => {
                    if (toClearPath) {
                        item.delete = true;

                        if (item.parent === parentSource) {
                            toClearPath = false;
                            path = path.filter(item => !item.delete);
                            path.reverse();
                        }
                    }
                })
            }

            if (!isFound) {
                if (typeof parentSource[propSource] === 'object') {
                    path.push({
                        prop: propSource,
                        parent: parentSource
                    });
                }

                if (valueSource == value && prop === propSource) {
                    isFound = true;
                } else if (Object.keys(parentSource).pop() === propSource && typeof parentSource[propSource] !== 'object') {
                    toClearPath = true;
                }
            }
        });

        return path.map(item => item.prop).join('.');
    }

    prepareAppTemplate(appToTemplate) {
        const self = this;

        let app = JSON.parse(JSON.stringify(appToTemplate));

        self.crawling(app.views_list, function (prop, value, parent) {
            if (prop == "element_id") {
                parent.element_id = -Number(value);
                parent.create_element = -Number(value);
            }
        })

        app.field_list.forEach(field => {
            field.create_field = -Number(field.field_id);
            field.element_id = -Number(field.field_id);
            field.field_id = -Number(field.field_id);
            field.field_value = ""; /* Should be removed when we update createApp API*/
        })

        app.items_list = [];

        delete app.app_id;
        delete app.icon.id;
        delete app.group_id;
        delete app.trash;
        delete app.last_update;
        delete app.file_list;

        return app;
    };

}